import {GetHeaderUspsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {COLORS} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {USP_BANNER_HEIGHT} from '../Header/constants';
import {UspBannerItem} from './UspBannerItem';

export const UspBannerView: React.FC<GetHeaderUspsResponse> = ({usps}) => {
  return (
    <Wrapper data-testid="USP_Banner_Wrapper">
      <UspItemsWrapper data-testid="USP_Banner_Content">
        {usps.map((usp, index) => (
          <UspBannerItem
            key={`usp_item_${index}`}
            href={usp.href}
            image={usp.image}
            isVip={usp.isVip}
            label={usp.label}
          />
        ))}
      </UspItemsWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  background: ${COLORS.Black};
  width: 100%;
  height: ${USP_BANNER_HEIGHT}px;
  display: flex;
  flex-shrink: 0;
`;

const UspItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  width: 100%;
  height: 100%;
  white-space: nowrap;
  padding: 0 50px;
`;
